import {geoConstants} from "./geo.constants";
import {geoService} from "./geo.service";
import {toastHelper} from "../../utils/toast-helper";

export const geoActions = {
    fetchVilles,
    clear,
};

function fetchVilles() {
    return dispatch => {
        dispatch(request());
        geoService.fetchVilles()
            .then(
                data => dispatch(success(data)),
                error => {
                    dispatch(failure(error.toString()));
                    toastHelper.error("Erreur lors du chargement des villes");
                }
            );
    };

    function request() { return { type: geoConstants.VILLES_FETCH_REQUEST }; }
    function success(villes) { return { type: geoConstants.VILLES_FETCH_SUCCESS, villes }; }
    function failure(error) { return { type: geoConstants.VILLES_FETCH_FAILURE, error }; }
}

function clear() {
    return { type: geoConstants.CLEAR };
}
